import React, { Component } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./AttendencePage.css";
import { toast } from "react-toastify";
import configData from "../config.json";
// import moment from "moment";
import {
  Button,
  Modal,
  Form,
  Tooltip,
  OverlayTrigger,
  Row,
  Col,
} from "react-bootstrap";
import moment from "moment";

import LoadingOverlay from "./LoadingOverlay";
export default class AttendancePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      data: [],
      dataActual: [],
      leavedata: [],
      errors: {},
      markAttendanceDate: new Date(),
      note: "",
      regularizeAttendanceDate: new Date(),
      attended: [],
      LeaveBalance: "",
      filteredData: null,
      totalDaysInMonth: 0,
      Holidays: [],
      groupedData: [],
      currentMonthName: new Date().toLocaleDateString("en-GB", {
        month: "long",
      }),
      disabledDates: this.loadDisabledDatesFromStorage() || [],
      todayDay: new Date().toLocaleDateString("en-US", { weekday: "long" }),
      time: new Date().toLocaleTimeString(),
      currentDate: new Date().toLocaleDateString("en-GB"),
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      totalWorkingDays: 0,
      presentDays: 0,
      absentDays: 0,
      halfDays: 0,
      lateDays: 0,
      holidays: 0,
      regularizedDays: 0,
      regularizedLeaveDates: [],
      regularizedDates: [],
      absentDates: [],
      compOffDates: [],
      seletctedDate: "",
      months: [],
      isRegularizing: false,
      isMarkingAttendance: false,
    };
  }
  normalizeDateList = (value) => {
    if (Array.isArray(value)) {
      return value.filter(Boolean);
    }
    if (!value) {
      return [];
    }
    if (typeof value === "string") {
      return [value];
    }
    return [];
  };
  expandDateRange = (fromDate, toDate) => {
    if (!fromDate || !toDate) {
      return [];
    }

    const dates = [];
    const start = new Date(fromDate);
    const end = new Date(toDate);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      return [];
    }

    for (
      let current = new Date(start);
      current <= end;
      current.setDate(current.getDate() + 1)
    ) {
      dates.push(moment(current).format("YYYY-MM-DD"));
    }

    return dates;
  };
  getLast12Months() {
    let months = [];
    let currentDate = new Date();
    for (let i = 0; i < 12; i++) {
      let seletctedDate = "";
      let monthDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - i,
        1,
      );
      // console.log(monthDate, "monthDate");
      months.push({
        value: monthDate.toLocaleDateString("en-CA", {
          year: "numeric",
          month: "2-digit",
        }), // Format: YYYY-MM
        label: monthDate.toLocaleString("default", {
          month: "long",
          year: "numeric",
        }),
      });
      // console.log(months);
      if (i === 0) {
        // console.log(monthDate, "monthDate");
        seletctedDate = months[i]["value"];
        // console.log(seletctedDate, "seletctedDate");
        this.setState({ seletctedDate: seletctedDate });
      }
    }
    this.setState({ months: months });
  }
  handleButtonClick = () => {
    this.inputFileRef.current.click();
  };
  handleCloseOne = () => {
    this.setState({ showOne: false });
  };
  handleShow = () => {
    this.setState({ show: true });
  };

  handleShowOne = () => {
    this.setState({ showOne: true });
  };
  //Offcanvas
  handleClick = () => {
    this.setState({ showButton: true });
  };
  handleClose = () => {
    this.setState({ show: false });
  };
  handleReguralizeDateChange = (date) => {
    this.setState({ regularizeAttendanceDate: date });
  };

  handleNoteChange = (event) => {
    this.setState({ note: event.target.value });
  };

  isDateDisabledOne = ({ date }) => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const currentDay = currentDate.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    const day = date.getDate();
    const dayOfWeek = date.getDay();
    let isDisabled = true;
    if (year === currentYear && month === currentMonth && day <= currentDay) {
      isDisabled = false;
    }
    const formattedDate = `${year}-${(month + 1)
      .toString()
      .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
    const isMarkedAttendance = this.state.data.includes(formattedDate);
    if (isMarkedAttendance) {
      isDisabled = true;
    }
    const dateString = `${year}-${
      month + 1 < 10 ? "0" + (month + 1) : month + 1
    }-${day < 10 ? "0" + day : day}`;
    const holiday = this.state.Holidays.find(
      (holiday) => holiday.Date === dateString,
    );
    if (holiday) {
      isDisabled = true;
    }
    if (date.getDay() === 0) {
      isDisabled = true;
    }
    const isApprovedLeave =
      (this.state.leaveRequestDates || []).includes(formattedDate) ||
      (this.state.compOffDates || []).includes(formattedDate) ||
      (this.state.leavedata || []).includes(formattedDate);
    if (isApprovedLeave) {
      isDisabled = true;
    }
    if (
      dayOfWeek === 0 ||
      holiday ||
      isMarkedAttendance ||
      isApprovedLeave
    ) {
      return true;
    }
    return isDisabled;
  };
  tileClassNameOne = ({ date }) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dateString = `${year}-${month < 10 ? "0" + month : month}-${
      day < 10 ? "0" + day : day
    }`;
    const holiday = this.state.Holidays.find(
      (holiday) => holiday.Date === dateString,
    );
    const isHoliday = holiday !== undefined;
    const isSaturday = date.getDay() === 6;
    const lastDayOfMonth = new Date(year, month, 0).getDate();
    const isLastSaturday = isSaturday && day > lastDayOfMonth - 7;
    const selectedDate = this.state.regularizeAttendanceDate
      .toISOString()
      .split("T")[0];
    const isSelectedDisabledDate = dateString === selectedDate;

    const isRegularized = this.state.regularizedDates.includes(dateString);
    const isDisabledDate = this.state.disabledDates.includes(dateString);

    if (isRegularized) {
      return "regularized";
    } else if (isHoliday) {
      return "holiday";
    } else if (isLastSaturday) {
      return "last-saturday";
    } else if (isSelectedDisabledDate) {
      return "selected-disabled-date";
    } else if (isDisabledDate) {
      return "regularization-request";
    } else {
      return null;
    }
  };

  loadDisabledDatesFromStorage() {
    const disabledDates = JSON.parse(localStorage.getItem("disabledDates"));
    return disabledDates;
  }
  saveDisabledDatesToStorage(disabledDates) {
    localStorage.setItem("disabledDates", JSON.stringify(disabledDates));
  }
  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.isRegularizing) return;
    const selectedDate = new Date(this.state.regularizeAttendanceDate);
    const formattedDate = `${selectedDate.getFullYear()}-${(
      selectedDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${selectedDate.getDate().toString().padStart(2, "0")}`;
    // 1️⃣ Check Holiday
    if (this.isDateDisabled({ date: selectedDate })) {
      this.showToast(
        "Cannot regularize attendance on Holidays, Sundays or Non-Last Saturdays.",
        "error",
      );
      return;
    }
    // 2️⃣ Check Leave Request
    if (
      this.state.leaveRequestDates.includes(formattedDate) ||
      this.state.leavedata.includes(formattedDate)
    ) {
      this.showToast(
        "You have already taken leave on this day. Cannot regularize attendance.",
        "error",
      );
      return;
    }
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("reason", this.state.note);
    formData.append("date", formattedDate);
    formData.append("status", this.state.note);

    this.setState({ isRegularizing: true });
    fetch(configData.api_url + "C_Employees/regulariseAttendance", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const updatedDisabledDates = [
            ...this.state.disabledDates,
            formattedDate,
          ];
          this.setState({
            showOne: false,
            disabledDates: updatedDisabledDates,
            regularizeAttendanceDate: new Date(),
            note: "",
            isRegularizing: false,
          });
          localStorage.setItem(
            "disabledDates",
            JSON.stringify(updatedDisabledDates),
          );
        } else {
          this.setState({ isRegularizing: false });
        }
      })
      .catch((error) => {
        console.error("Error regularizing attendance:", error);
        this.showToast("Error regularizing attendance.", "error");
        this.setState({ isRegularizing: false });
      });
  };

  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  componentDidMount() {
    this.getLast12Months();
    this.AttendencefetchHandler();
    this.HolidayslistfetchHandler();
    this.fetchDisabledDates();
    this.updateTime();
    this.getleaveBalance();
    this.fetchDataForMonth(this.state.currentMonth, this.state.currentYear);
    //this.timerID = setInterval(() => this.updateTime(), 1000);
    const disabledDates =
      JSON.parse(localStorage.getItem("disabledDates")) || [];
    this.setState({ disabledDates });
    this.LeaverequestapprovalsfetchHandler();
  }
  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  updateTime = () => {
    setInterval(() => {
      this.setState({ time: new Date().toLocaleTimeString() });
    }, 1000);
  };

  handleClockInOut = () => {
    this.setState((prevState) => ({ clockedIn: !prevState.clockedIn }));
  };
  fetchDisabledDates() {
    const disabledDates = [];
    this.setState({ disabledDates });
  }
  fetchDataForMonth = (month, year) => {
    this.HolidayslistfetchHandler(month, year);
    this.AttendencefetchHandler(month, year);
  };
  LeaverequestapprovalsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Leaverequestapprovals/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const leaveDates = [];
          const compOffDates = [];
          const list = Array.isArray(data.list) ? data.list : [];

          const cancelledDatesByParent = {};
          list.forEach((record) => {
            if (
              record?.recordType === "cancellation" &&
              record?.cancellationDecision === "Approved" &&
              record?.parentLeaveId
            ) {
              let dates = [];
              try {
                dates = JSON.parse(record.cancellationDates) || [];
              } catch (e) {
                dates = [];
              }
              if (!cancelledDatesByParent[record.parentLeaveId]) {
                cancelledDatesByParent[record.parentLeaveId] = new Set();
              }
              dates.forEach((d) =>
                cancelledDatesByParent[record.parentLeaveId].add(d),
              );
            }
          });

          const approvedLeaves = list.filter(
            (leave) =>
              leave?.Decision === "Approved" &&
              leave?.recordType !== "cancellation",
          );

          approvedLeaves.forEach((leave) => {
            const fromDate = new Date(leave.FromDate);
            const toDate = new Date(leave.ToDate);
            const isCompensatory = leave.LeaveType === "Compensatory Leave";
            const cancelledDates =
              cancelledDatesByParent[leave.leaverequestapprovals_Id] ||
              new Set();

            for (
              let date = new Date(fromDate);
              date <= toDate;
              date.setDate(date.getDate() + 1)
            ) {
              const dateStr = `${date.getFullYear()}-${
                date.getMonth() + 1 < 10
                  ? "0" + (date.getMonth() + 1)
                  : date.getMonth() + 1
              }-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}`;
              if (cancelledDates.has(dateStr)) continue;
              if (isCompensatory) {
                compOffDates.push(dateStr);
              } else {
                leaveDates.push(dateStr);
              }
            }

          });
          this.setState({
            leaveRequestDates: leaveDates,
            compOffDates,
          });
        } else {
          this.setState({ leaveRequestDates: [] });
        }
      });
  };
  getleaveBalance = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("employees_Id", this.state.uId);
    fetch(configData.api_url + "C_Employees/retrive", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ LeaveBalance: data.detail.leaves });
        }
      });
  };
  HolidayslistfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Holidayslist/list", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ Holidays: data.list }, this.calculateStats);
        }
      });
  };
  AttendencefetchHandler = () => {
    var formData = new FormData();
    const { currentYear, currentMonth } = this.state;
    const monthParam = `${currentYear}-${String(currentMonth).padStart(2, "0")}`;
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("month", monthParam);
    fetch(configData.api_url + "C_Employees/getattendance", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const attendedList = this.normalizeDateList(data?.list?.attended);
          const regularizedList = this.normalizeDateList(
            data?.list?.regularize,
          );
          const leaveList = this.normalizeDateList(data?.list?.leave).map(
            (dateTime) => String(dateTime).split(" ")[0],
          );
          const absentDates = this.expandDateRange(
            data?.list?.absent?.FromDate,
            data?.list?.absent?.ToDate,
          );
          // Filter out null values and then normalize the attendance dates
          const normalizedAttendance = attendedList.map(
            (dateTime) => dateTime.split(" ")[0],
          );
          const normalizedRegularized = regularizedList.map(
            (dateTime) => dateTime.split(" ")[0],
          );

          const totalLeavesTaken = leaveList.filter((date) => {
            const d = new Date(date);
            return (
              !Number.isNaN(d.getTime()) &&
              d.getMonth() + 1 === this.state.currentMonth &&
              d.getFullYear() === this.state.currentYear
            );
          }).length;

          this.setState(
            {
              dataActual: attendedList,
              data: normalizedAttendance,
              leavedata: leaveList,
              regularizedDates: normalizedRegularized,
              absentDates,
              totalLeavesTaken,
            },
            () => {
              this.groupDataByYearAndMonth();
              this.calculateStats();
            },
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching attendance:", error);
      });
  };

  groupDataByYearAndMonth = () => {
    const { data } = this.state;
    let groupedData = {};

    data.forEach((attendance) => {
      // Additional safety check
      if (!attendance) return;

      const date = new Date(attendance);
      const year = date.getFullYear();
      const month = date.getMonth();

      if (!groupedData[year]) {
        groupedData[year] = [];
      }
      if (!groupedData[year][month]) {
        groupedData[year][month] = [];
      }
      groupedData[year][month].push(attendance);
    });

    const formattedGroupedData = Object.keys(groupedData).map((year) => ({
      year,
      months: groupedData[year]
        .map((monthData, monthIndex) => {
          // Only include months that have data
          if (!monthData || monthData.length === 0) return null;
          return {
            month: monthIndex + 1,
            data: monthData,
          };
        })
        .filter(Boolean), // Remove null entries
    }));

    this.setState({ groupedData: formattedGroupedData });
  };

  calculateStats = () => {
    const {
      data,
      dataActual,
      leavedata,
      regularizedDates,
      Holidays,
      currentMonth,
      currentYear,
    } = this.state;
    const daysInMonth = new Date(currentYear, currentMonth, 0).getDate();
    let presentDays = 0;
    let absentDays = 0;
    let holidays = 0;
    let totalWorkingDays = 0;
    let regularizedDays = 0;
    let regularizedLeaveDates = [];
    let approvedLeaveDays = 0;
    let lateDays = 0;

    // Debug arrays to track which days are counted in each category
    let presentDaysArray = [];
    let regularizedDaysArray = [];
    let approvedLeaveDaysArray = [];
    let workingDaysArray = [];

    const totalDaysInMonth = daysInMonth;

    // Calculate holidays in current month
    Holidays.forEach((holiday) => {
      const holidayDate = new Date(holiday.Date);
      if (
        holidayDate.getMonth() + 1 === currentMonth &&
        holidayDate.getFullYear() === currentYear
      ) {
        holidays++;
      }
    });

    // Calculate total working days
    for (let i = 1; i <= daysInMonth; i++) {
      const date = moment(
        `${currentYear}-${String(currentMonth).padStart(2, "0")}-${String(
          i,
        ).padStart(2, "0")}`,
        "YYYY-MM-DD",
      ).format("YYYY-MM-DD");

      const day = new Date(date).getDay();
      const isHoliday = Holidays.some((holiday) => holiday.Date === date);
      const isWeekend = day === 0;

      if (!isHoliday && !isWeekend) {
        totalWorkingDays++;
      }
    }

    // Get all approved leave dates
    let approvedLeaveDates = [];
    if (
      this.state.leaveRequestDates &&
      this.state.leaveRequestDates.length > 0
    ) {
      approvedLeaveDates = [...this.state.leaveRequestDates];
    }
    // Include comp off dates as approved leave
    if (this.state.compOffDates && this.state.compOffDates.length > 0) {
      approvedLeaveDates = [...approvedLeaveDates, ...this.state.compOffDates];
    }

    // Calculate not marked days only up to today
    const today = moment().format("YYYY-MM-DD");

    // First determine all working days until today
    let workingDaysUntilToday = 0;
    for (let i = 1; i <= daysInMonth; i++) {
      const date = moment(
        `${currentYear}-${String(currentMonth).padStart(2, "0")}-${String(
          i,
        ).padStart(2, "0")}`,
        "YYYY-MM-DD",
      ).format("YYYY-MM-DD");

      if (date > today) break; // Stop counting after today

      const day = new Date(date).getDay();
      const isHoliday = Holidays.some((holiday) => holiday.Date === date);
      const isWeekend = day === 0;

      if (!isHoliday && !isWeekend) {
        workingDaysUntilToday++;
        workingDaysArray.push(date); // Track for debugging
      }
    }

    // Process each working day to categorize attendance
    for (let i = 0; i < workingDaysArray.length; i++) {
      const date = workingDaysArray[i];
      let dayStatus = "absent"; // Default status

      const isPresent = data.some((attendanceDate) => {
        const attendanceOnlyDate = attendanceDate.split(" ")[0];
        return attendanceOnlyDate === date;
      });

      // Check for attendance by comparing only the date part
      const isLate = dataActual.some((attendanceDate) => {
        let isLateReturn = false;
        const attendanceOnlyDate = attendanceDate.split(" ")[0];
        if (attendanceOnlyDate === date) {
          // console.log(attendanceOnlyDate,"actualDate");
          const actualDate = new Date(`${attendanceOnlyDate}T10:15:00`);
          const givenDateTime = new Date(attendanceDate);
          const isLateDate = givenDateTime.getTime();
          const isactualdateDate = actualDate.getTime();
          // console.log(attendanceDate,"attendanceDate");
          if (isLateDate > isactualdateDate) {
            // console.log(attendanceDate,"attendanceDate");
            isLateReturn = true;
          }
        }
        return isLateReturn;
      });

      if (isPresent) {
        // console.log(date);
        presentDays++;
        if (isLate) {
          lateDays++;
        }
        presentDaysArray.push(date); // Track for debugging
        dayStatus = "present";
      }

      // Only check for leave if not present
      if (dayStatus === "absent") {
        // Check for regularized leave
        const isRegularizedLeave = regularizedDates.includes(date);

        if (isRegularizedLeave) {
          regularizedDays++;
          regularizedLeaveDates.push(date);
          regularizedDaysArray.push(date); // Track for debugging
          dayStatus = "regularized";
        }
      }

      // Only check for approved leave if not present and not regularized
      if (dayStatus === "absent") {
        // Check if the date is in approved leave dates
        const isApprovedLeave = approvedLeaveDates.includes(date);
        if (isApprovedLeave) {
          approvedLeaveDays++;
          approvedLeaveDaysArray.push(date); // Track for debugging
          dayStatus = "approved leave";
        }
      }
    }

    // Calculate absent days correctly - ensure it's never negative
    absentDays = Math.max(
      0,
      workingDaysUntilToday -
        (presentDays + regularizedDays + approvedLeaveDays),
    );

    // Log debug information

    this.setState({
      totalWorkingDays,
      presentDays,
      absentDays,
      holidays,
      totalDaysInMonth,
      regularizedDays,
      regularizedLeaveDates,
      approvedLeaveDays,
      lateDays,
      // Add these for debugging if needed
      workingDaysCount: workingDaysUntilToday,
      presentDaysCount: presentDays,
      regularizedDaysCount: regularizedDays,
      approvedLeaveDaysCount: approvedLeaveDays,
    });
  };

  handleMonthYearChange = (event) => {
    const selectedDate = event.target.value;
    const [year, month] = event.target.value.split("-").map(Number);
    const newCalendarViewDate = new Date(year, month - 1, 1);
    this.setState(
      {
        //seletctedDate: event.target.value,
        seletctedDate: selectedDate,
        currentYear: year,
        currentMonth: month,
        calendarViewDate: newCalendarViewDate,
      },
      () => {
        this.LeaverequestapprovalsfetchHandler();
        this.fetchDataForMonth(month, year);
      },
    );
  };

  AttendencesubmitHandler = (e) => {
    e.preventDefault();
    if (this.state.isMarkingAttendance) return;
    const selectedDate = this.state.markAttendanceDate;
    const currentDate = new Date().toISOString().split("T")[0];
    const formattedSelectedDate = `${selectedDate.getFullYear()}-${(
      selectedDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${selectedDate.getDate().toString().padStart(2, "0")}`;
    const isCurrentDateMarked = this.state.data.includes(currentDate);
    const isCurrentDate = formattedSelectedDate === currentDate;
    // Check if the selected date is in leaveRequestDates
    if (
      this.state.leaveRequestDates.includes(formattedSelectedDate) ||
      this.state.leavedata.includes(formattedSelectedDate)
    ) {
      this.showToast(
        "You have taken leave on this day. Attendance cannot be marked.",
        "error",
      );
      return;
    }
    // 2️⃣ Check Regularize
    if (
      this.state.regularizedDates &&
      this.state.regularizedDates.includes(formattedSelectedDate)
    ) {
      this.showToast(
        "This date is already regularized. Attendance cannot be marked again.",
        "error",
      );
      return;
    }

    if (!isCurrentDateMarked && !isCurrentDate) {
      this.showToast(
        "Please Mark Attendance For Current Date Only. For Old Dates Use Regralize Attendance.",
        "error",
      );
      return;
    }
    if (isCurrentDateMarked && !isCurrentDate) {
      this.showToast("Attendance Already Marked For Current Date", "error");
      return;
    }
    if (this.isDateDisabled({ date: selectedDate })) {
      this.showToast(
        "Cannot Mark Attendance On Holidays, Sundays, Or Non-Last Saturdays",
        "error",
      );
      return;
    }
    const now = new Date();
    const markTime = now.getHours() * 60 + now.getMinutes();
    const lateThreshold = 10 * 60 + 10;
    const isLate = markTime > lateThreshold;

    if (isLate) {
      this.showToast("Attendance Marked as Late.", "warning");
    }
    var formData = new FormData();
    const uId = sessionStorage.getItem("uId");
    const uName = sessionStorage.getItem("userName");
    const attendanceData = {
      uId,
      uName,
      markAttendanceDate: selectedDate,
    };
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("markAttendanceDate", this.state.markAttendanceDate);
    formData.append("isLate", isLate);
    this.setState({ isMarkingAttendance: true });
    fetch(configData.api_url + "C_Employees/markattendance", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.AttendencefetchHandler();
          this.setState(
            (prevState) => ({
              attended: [...prevState.attended, attendanceData],
              isMarkingAttendance: false,
            }),
            () => {
              this.calculateStats();
              this.HolidayslistfetchHandler();
              this.AttendencefetchHandler();
            },
          );
        } else {
          this.setState({ isMarkingAttendance: false });
        }
      })
      .catch((error) => {
        console.error("Error marking attendance:", error);
        this.showToast("Error marking attendance.", "error");
        this.setState({ isMarkingAttendance: false });
      });
  };
  // Add this helper function to check if a specific date is late
  isDateLate = (dateString) => {
    return this.state.dataActual.some((attendanceDate) => {
      if (!attendanceDate) return false; // Skip null entries

      const attendanceOnlyDate = attendanceDate.split(" ")[0];
      if (attendanceOnlyDate === dateString) {
        // Check if attendance time is after 10:15 AM
        const actualDate = new Date(`${attendanceOnlyDate}T10:15:00`);
        const givenDateTime = new Date(attendanceDate);
        const isLateTime = givenDateTime.getTime();
        const actualDateTime = actualDate.getTime();

        return isLateTime > actualDateTime;
      }
      return false;
    });
  };
  tileClassName = ({ date }) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dateString = `${year}-${month < 10 ? "0" + month : month}-${
      day < 10 ? "0" + day : day
    }`;
    const today = moment().format("YYYY-MM-DD");
    const datetoday = moment(
      `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`,
      "YYYY-MM-DD",
    ).format("YYYY-MM-DD");

    const leaveDates = this.normalizeDateList(this.state.leavedata).map(
      (leave) => leave.split(" ")[0],
    );
    const isRegularized = this.state.regularizedDates.includes(dateString);
    const holiday = this.state.Holidays.find(
      (holiday) => holiday.Date === dateString,
    );
    const isLeave = leaveDates.includes(dateString);
    const isAbsent = this.state.absentDates.includes(dateString);
    const isAttendance = this.state.data.find(
      (attendance) => attendance === dateString,
    );
    const isHoliday = holiday !== undefined;
    // const isSaturday = date.getDay() === 6;
    // const lastDayOfMonth = new Date(year, month, 0).getDate();
    // const isLastSaturday = isSaturday && day > lastDayOfMonth - 7;
    const isSunday = date.getDay() === 0;
    const isWorkingDay = !isHoliday && !isSunday;
    const isLeaveRequest = this.state.leaveRequestDates?.includes(dateString);
    const isCompOff = this.state.compOffDates?.includes(dateString);
    const isUnmarkedWorkingDay =
      isWorkingDay &&
      !isAttendance &&
      !isLeave &&
      !isLeaveRequest &&
      !isCompOff;
    if (isLeave) {
      return "leave-date";
    } else if (isRegularized) {
      return "regularized";
    } else if (isHoliday) {
      return "holiday";
      // } else if (isLastSaturday) {
      //   return "last-saturday";
    } else if (isAttendance && this.isDateLate(dateString)) {
      return "late-attendance";
    } else if (isAttendance) {
      return "attendance-date";
    } else if (isCompOff) {
      return "compoff-date";
    } else if (isLeaveRequest) {
      return "leave-request";
    } else if (isAbsent) {
      return "absent-date";
    } else if (datetoday > today && !isHoliday && !isSunday) {
      return "future-date";
    } else if (isUnmarkedWorkingDay) {
      return "unmarked-working-day";
    } else {
      return null;
    }
  };
  isDateDisabled = ({ date }) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dayOfWeek = date.getDay();
    const dateString = `${year}-${month < 10 ? "0" + month : month}-${
      day < 10 ? "0" + day : day
    }`;
    const holiday = this.state.Holidays.find(
      (holiday) => holiday.Date === dateString,
    );
    // const lastDayOfMonth = new Date(year, month, 0).getDate();
    // const isLastSaturday = dayOfWeek === 6 && day > lastDayOfMonth - 7;

    // if ((dayOfWeek === 6 && !isLastSaturday) || dayOfWeek === 0 || holiday) {
    if (dayOfWeek === 0 || holiday) {
      return true;
    }
    return false;
  };
  handleDateChange = (date) => {
    this.setState({ markAttendanceDate: date });
  };
  formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };
  render() {
    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 10);
    return (
      <div>
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <Row className="mb-2">
          <div className="col-md-3">
            <div className="widget_BG widget_BG_grid">
              {/* <h3 className="">Attendance {uName}</h3> */}

              <h3 className="">Attendance Page</h3>
            </div>
          </div>
          <div className="col-md-5 text-center">
            <div className="widget_BG">
              <button
                type="button"
                className="btn btn-primary border_radius mx-3 markAttendance_btn_color "
                onClick={this.AttendencesubmitHandler}
                disabled={this.state.isMarkingAttendance}
              >
                {this.state.isMarkingAttendance ? "Marking..." : "Mark Attendance"}
              </button>

              <button
                type="button"
                className="btn btn-primary border_radius regularize_attendance"
                onClick={this.handleShowOne}
              >
                Regularize Attendance
              </button>
            </div>
          </div>
          <div className="col-md-4 text-end">
            <div className="widget_BG widget_BG_grid text-end">
              <h4>
                {this.state.currentDate} {this.state.time} {this.state.todayDay}
              </h4>
            </div>
          </div>
        </Row>
        <div>
          <Modal show={this.state.showOne} onHide={this.handleCloseOne}>
            <Modal.Header closeButton>
              <Modal.Title>Regularize note</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Calendar
                onChange={this.handleReguralizeDateChange}
                value={this.state.regularizeAttendanceDate}
                maxDate={new Date()}
                defaultValue={this.state.date}
                tileDisabled={this.isDateDisabledOne}
                tileClassName={this.tileClassNameOne}
                tileContent={({ date, view }) => {
                  if (view === "month") {
                    const year = date.getFullYear();
                    const month = date.getMonth() + 1;
                    const day = date.getDate();
                    const dateString = `${year}-${
                      month < 10 ? "0" + month : month
                    }-${day < 10 ? "0" + day : day}`;
                    const holiday = this.state.Holidays.find(
                      (holiday) => holiday.Date === dateString,
                    );
                    if (holiday) {
                      return (
                        <OverlayTrigger
                          overlay={
                            <Tooltip id="tooltip">{holiday.Festival}</Tooltip>
                          }
                        >
                          <span className="d-inline-block holiday-tooltip">
                            {day}
                          </span>
                        </OverlayTrigger>
                      );
                    } else {
                      return <span className="d-inline-block">{day}</span>;
                    }
                  }
                }}
              />
              <br />
              <Form.Group className="form-group">
                <Form.Label className="control-label">
                  Please Enter Regularize note
                </Form.Label>
                <Form.Control
                  as="textarea"
                  name="note"
                  value={this.state.note}
                  rows={5}
                  onChange={this.handleNoteChange}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleCloseOne}>
                Close
              </Button>
              <Button variant="primary" onClick={this.handleSubmit} disabled={this.state.isRegularizing}>
                {this.state.isRegularizing ? "Submitting..." : "Submit"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <div className="attendance_page">
          <Row>
            <Col lg="4" md="4">
              <Calendar
                onChange={this.handleDateChange}
                value={this.state.markAttendanceDate}
                activeStartDate={this.state.calendarViewDate}
                onActiveStartDateChange={this.handleActiveStartDateChange}
                tileClassName={this.tileClassName}
                tileDisabled={this.isDateDisabled}
                tileContent={({ date, view }) => {
                  if (view === "month") {
                    const year = date.getFullYear();
                    const month = date.getMonth() + 1;
                    const day = date.getDate();
                    const dateString = `${year}-${
                      month < 10 ? "0" + month : month
                    }-${day < 10 ? "0" + day : day}`;
                    const today = moment().format("YYYY-MM-DD");
                    const datetoday = moment(
                      `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`,
                      "YYYY-MM-DD",
                    ).format("YYYY-MM-DD");
                    const holiday = this.state.Holidays.find(
                      (holiday) => holiday.Date === dateString,
                    );
                    const isHoliday = holiday !== undefined;
                    const isSunday = date.getDay() === 0;
                    const leaveDates = this.normalizeDateList(this.state.leavedata).map(
                      (leave) => leave.split(" ")[0],
                    );
                    const isRegularized = this.state.regularizedDates.includes(dateString);
                    const isAttendance = this.state.data.find(
                      (attendance) => attendance === dateString,
                    );
                    const isLate = isAttendance && this.isDateLate(dateString);
                    const isCompOff = this.state.compOffDates?.includes(dateString);
                    const isLeaveRequest = this.state.leaveRequestDates?.includes(dateString);
                    const isLeave = leaveDates.includes(dateString);
                    const isAbsent = this.state.absentDates.includes(dateString);
                    const isWorkingDay = !isHoliday && !isSunday;
                    const isUnmarkedWorkingDay = isWorkingDay && !isAttendance && !isLeave && !isLeaveRequest && !isCompOff && !isRegularized;

                    // Determine tooltip text based on same priority as tileClassName
                    let tooltipText = null;
                    if (datetoday > today && !isHoliday && !isSunday && !isLeave) {
                      tooltipText = null; // Future date — no tooltip
                    } else if (isLeave) {
                      tooltipText = "Leave";
                    } else if (isRegularized) {
                      tooltipText = "Regularized";
                    } else if (isHoliday) {
                      tooltipText = holiday.Festival;
                    } else if (isLate) {
                      tooltipText = "Late Attendance";
                    } else if (isAttendance) {
                      tooltipText = "Attendance Marked";
                    } else if (isCompOff) {
                      tooltipText = "Comp Off Day";
                    } else if (isLeaveRequest) {
                      tooltipText = "Leave Taken";
                    } else if (isAbsent) {
                      tooltipText = "Not Marked";
                    } else if (isUnmarkedWorkingDay && datetoday <= today) {
                      tooltipText = "Not Marked";
                    }

                    if (tooltipText) {
                      return (
                        <OverlayTrigger
                          overlay={<Tooltip id="tooltip">{tooltipText}</Tooltip>}
                        >
                          <span className={`d-inline-block${isHoliday ? " holiday-tooltip" : ""}`}>
                            {day}
                          </span>
                        </OverlayTrigger>
                      );
                    }
                    return <span className="d-inline-block">{day}</span>;
                  }
                }}
              />
            </Col>
            <Col className="col-md-8">
              <div className="overview-section">
                <Row className="mb-3">
                  <div className="col-md-6 ">
                    <div className="date-selectors">
                      <select
                        value={this.state.seletctedDate}
                        onChange={this.handleMonthYearChange}
                        className="form-select border_radius"
                        //key="yearmonthselector"
                      >
                        {this.state.months.map((month) => (
                          <option key={month.value} value={month.value}>
                            {month.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6  text-end">
                    <h4>
                      For The Month of <i>{this.state.currentMonthName}</i>{" "}
                      {this.state.currentYear}
                    </h4>
                  </div>
                </Row>
                <Row className="text-center overviewSection">
                  <div className="col-md-3 overviewCol">
                    <strong>Total Days</strong>
                    <div className="alert alert-primary" role="alert">
                      {this.state.totalDaysInMonth}
                    </div>
                  </div>
                  <div className="col-md-3 overviewCol">
                    <strong>Total Working Days</strong>
                    <div className="alert alert-secondary" role="alert">
                      {this.state.totalWorkingDays}
                    </div>
                  </div>
                  <div className="col-md-3 overviewCol">
                    <strong>Present Days</strong>
                    <div className="alert alert-success" role="alert">
                      {this.state.presentDays}
                    </div>
                  </div>
                  <div className="col-md-3 overviewCol">
                    <strong>Not Marked Days</strong>
                    <div className="alert alert-danger" role="alert">
                      {this.state.absentDays}
                    </div>
                  </div>
                  <div className="col-md-3 overviewCol">
                    <strong>Regularize Request</strong>
                    <div className="alert alert-warning" role="alert">
                      {this.state.regularizedDays}
                    </div>
                  </div>
                  <div className="col-md-3 overviewCol">
                    <strong>Late Attendance</strong>
                    <div className="alert alert-info" role="alert">
                      {this.state.lateDays}
                    </div>
                  </div>
                  <div className="col-md-3 overviewCol">
                    <strong>Leave Taken</strong>
                    <div className="alert alert-light" role="alert">
                      {this.state.totalLeavesTaken}
                    </div>
                  </div>
                  <div className="col-md-3 overviewCol">
                    <strong>Holidays This Month</strong>
                    <div className="alert alert-dark" role="alert">
                      {this.state.holidays}
                    </div>
                  </div>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
